import { render, staticRenderFns } from "./TestTecords.vue?vue&type=template&id=15410dea&scoped=true"
import script from "./TestTecords.vue?vue&type=script&lang=js"
export * from "./TestTecords.vue?vue&type=script&lang=js"
import style0 from "./TestTecords.vue?vue&type=style&index=0&id=15410dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15410dea",
  null
  
)

export default component.exports